import React from 'react';

import { BellOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  justify-content: end;
  align-items: center;
  margin: 0 20px;

  .beamer_icon.active {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    width: 14px;
    height: 14px;
  }
`;

const HeaderNotifications = () => (
  <Container>
    <BellOutlined style={{ fontSize: 20 }} className={'beamerButton'} />
  </Container>
);

export default HeaderNotifications;
